import { CSSProperties } from "react"

export const SvgCarretArrow = ({
  className,
  fillColor,
  style,
  strokeWidth,
}: {
  className?: string
  fillColor?: string
  style?: CSSProperties
  strokeWidth?: number
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 8 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path
      d="M1.08321 13.4166C0.967855 13.4166 0.855097 13.3824 0.759192 13.3183C0.663286 13.2542 0.588538 13.1631 0.544397 13.0565C0.500256 12.9499 0.488704 12.8327 0.511202 12.7195C0.5337 12.6064 0.589237 12.5024 0.670793 12.4209L6.09171 6.99995L0.670793 1.57904C0.564534 1.46902 0.505737 1.32167 0.507066 1.16872C0.508395 1.01577 0.569744 0.869463 0.677898 0.761308C0.786053 0.653154 0.93236 0.591805 1.08531 0.590476C1.23826 0.589147 1.38561 0.647944 1.49563 0.754203L7.32896 6.58754C7.43832 6.69693 7.49975 6.84527 7.49975 6.99995C7.49975 7.15463 7.43832 7.30298 7.32896 7.41237L1.49563 13.2457C1.38625 13.3551 1.23791 13.4166 1.08321 13.4166Z"
      fill={fillColor}
      stroke={fillColor}
      strokeWidth={strokeWidth ? strokeWidth : 0.5}
    />
  </svg>
)
